import React, { useEffect } from "react";

import { Add, FormClose, StatusGood } from "grommet-icons";

import { Box, Button, Layer, Text } from "grommet";

type NotificationAlertProps = {
  text: string;
  subText: string;
  showAlert: boolean;
  onCancelOrDone: () => void;
  noExpiring?: boolean;
};

export const NotificationAlert = ({
  text,
  subText,
  showAlert,
  onCancelOrDone,
}: NotificationAlertProps) => {
  return (
    // Uncomment <Grommet> lines when using outside of storybook
    // <Grommet theme={...}>
    <>
      {showAlert && (
        <Layer
          position="top"
          modal={false}
          margin={{ vertical: "medium", horizontal: "small" }}
          onEsc={onCancelOrDone}
          responsive={false}
          plain
        >
          <Box
            align="center"
            direction="row"
            gap="small"
            justify="between"
            round="medium"
            elevation="medium"
            pad={{ vertical: "xsmall", horizontal: "small" }}
            background="red"
          >
            <Box align="center" direction="row" gap="xsmall">
              <Box align="start" direction="column">
                <Text color={"white"}>{text}</Text>
                <Text color={"white"}>{subText}</Text>
              </Box>
            </Box>
            <Button
              icon={<FormClose color="white" />}
              onClick={onCancelOrDone}
              plain
            />
          </Box>
        </Layer>
      )}
    </>
    // </Grommet>
  );
};
